<div class="animations-container h-100 w-100" *ngIf='showingRotationAnimation'>
  <div class="screen-rotation-icon-container">
    <img class='screen-rotation-icon' src="assets/icons/screen_rotation_marela.svg" alt="" #ScreenRotation id="ScreenRotation">
    <!-- <span class="material-icons screen-rotation-icon" #ScreenRotation>
      screen_rotation
    </span> -->
  </div>
</div>

<div class="animations-container h-100 w-100" *ngIf='showingVerticalFingerAnimation'>
  <div class="finger-icon-container vertical">
    <img class='finger-icon' src="assets/icons/icon_finger.png" alt="" #VFinger>
  </div>
</div>

<div class="animations-container h-100 w-100" *ngIf='showingHorizontalFingerAnimation'>
  <div class="finger-icon-container horizontal">
    <img class='finger-icon' src="assets/icons/icon_finger.png" alt="" #HFinger>
  </div>
</div>